module.exports = __webpack_public_path__ + "img/aviation_mix8.f556dca6.jpg";